export default __webpack_public_path__ + "static/media/german.5d3ae113.svg";